import actions from './actions'
import mutations from './mutation'

const state = {
  activeTab: 'overview',
  //区块链列表
  chain_list: [],
  chain_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //合约管理
  chain_contract_list: [],
  chain_contract_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //上链管理
  upper_chain_list: [],
  upper_chain_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //组织管理
  chain_org_list: [],
  chain_org_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //节点管理
  chain_node_list: [],
  chain_node_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //链下扩容管理
  chain_off_chain_node_list: [],
  chain_off_chain_node_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //链下扩容通道管理
  chain_off_chain_chan_list: [],
  chain_off_chain_chan_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //用户管理
  chain_user_list: [],
  chain_user_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //密文
  chain_ciphertext_list: [],
  chain_ciphertext_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //投票管理
  chain_vote_list: [],
  chain_vote_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //归档查询
  archiving_info: {
    block: {}
  }
}

export default {
  state,
  actions,
  mutations
}
